var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 7.5h-3v-3a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v12a.75.75 0 0 0 1.219.583l3.281-2.645v2.812a1.5 1.5 0 0 0 1.5 1.5h8.774l3.507 2.833a.75.75 0 0 0 1-.053.75.75 0 0 0 .219-.53V9a1.5 1.5 0 0 0-1.5-1.5M6.24 12.917 3.75 14.93V4.5h12v8.25H6.71a.75.75 0 0 0-.47.167m14.01 6.513-2.49-2.013a.75.75 0 0 0-.468-.167H8.25v-3h7.5a1.5 1.5 0 0 0 1.5-1.5V9h3z"
  })));
};
export default SvgChat;